import React, { useState } from 'react';
import { Button, Radio } from '@grofers/dock-design-kit';
import ConfirmationModal from './ConfirmationModal';
import { DeniedItemsList } from './Resolution';

/**
 * Step 4 content when resolution-service found no viable remedy for this
 * complaint - there's nothing to pick an item/pickup/alternate-option for,
 * just a single confirmation before telling the customer no service is
 * being offered. No network call backs "Proceed" - `onComplete` resolves
 * entirely client-side (see CopilotView.js).
 */
const ServiceDenial = ({ onComplete = () => {}, deniedItems = [] }) => {
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  const handleConfirmServiceDenial = () => {
    setIsConfirmOpen(false);
    onComplete({ isServiceDenied: true });
  };

  return (
    <div className='tw-flex tw-flex-col tw-gap-[16px] tw-w-full tw-mt-4'>
      <p className='tw-flex tw-flex-wrap tw-gap-x-1 tw-text-[12px] tw-leading-tight tw-font-regular tw-text-grey-800 tw-m-0 tw-w-full'>
        <span>Proceed with</span>
        <span className='tw-font-semibold tw-text-red-600'>Service Denial</span>
        <span>and send the Recommended Response given below</span>
      </p>

      <div className='tw-flex tw-items-center tw-gap-[6px]'>
        <Radio size='sm' isSelected disabled />
        <p className='tw-text-[14px] tw-leading-[18px] tw-text-grey-900 tw-m-0'>
          Service No
        </p>
      </div>

      <DeniedItemsList items={deniedItems} />

      <div className='tw-flex tw-justify-end tw-w-full'>
        <Button
          variant='primary'
          buttonType='default'
          size='md'
          shape='square'
          onClick={() => setIsConfirmOpen(true)}
        >
          Proceed
        </Button>
      </div>

      <ConfirmationModal
        isOpen={isConfirmOpen}
        message={
          <div>
            <p className='tw-flex tw-flex-wrap tw-gap-x-1 tw-text-[14px] tw-leading-tight tw-font-regular tw-text-grey-800 tw-m-0 tw-w-full'>
              <span>Are you sure you want to proceed with</span>
              <span className='tw-font-semibold tw-text-grey-900'>
                Service Denial
              </span>
              <span>?</span>
              <span className='tw-font-semibold tw-text-grey-900 tw-mt-1 tw-text-[15px]'>
                No further changes can be made after this
              </span>
            </p>
          </div>
        }
        onCancel={() => setIsConfirmOpen(false)}
        onConfirm={handleConfirmServiceDenial}
      />
    </div>
  );
};

export default ServiceDenial;
